// src/store/slices/evl/evl0104m_slice.ts

import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import cloneDeep from "lodash/cloneDeep";
import type { IEvl0104mState, IEvl0104mRow, SelectOption, IEvl0104mFilters } from "../../models/evl/evl0104m_model";

const initialState: IEvl0104mState = {
  items: [],

  evlCdOptions: [{ label: "전체", value: "" }],
  itmTypCdOptions: [{ label: "전체", value: "" }],
  dtlTypCdOptions: [{ label: "전체", value: "" }],

  filters: {
    evlCd: "",
    itmTypCd: "",
    dtlTypCd: "",
    useYn: false,
    keyWord: "",
  },

  loading: false,
};

export const Evl0104m_Slice = createSlice({
  name: "Evl0104m_Slice",
  initialState,
  reducers: {
    initState: (state) => {
      const newState = cloneDeep(initialState);
      // 필요하면 유지하고 싶은 값만 남기기
      newState.items = state.items;
      return { ...newState };
    },

    setItems: (state, action: PayloadAction<IEvl0104mRow[]>) => {
      state.items = action.payload;
    },

    setOptions: (
      state,
      action: PayloadAction<{
        evlCdOptions?: SelectOption[];
        itmTypCdOptions?: SelectOption[];
        dtlTypCdOptions?: SelectOption[];
      }>
    ) => {
      if (action.payload.evlCdOptions) state.evlCdOptions = action.payload.evlCdOptions;
      if (action.payload.itmTypCdOptions) state.itmTypCdOptions = action.payload.itmTypCdOptions;
      if (action.payload.dtlTypCdOptions) state.dtlTypCdOptions = action.payload.dtlTypCdOptions;
    },

    setFilters: (state, action: PayloadAction<Partial<IEvl0104mFilters>>) => {
      Object.assign(state.filters, action.payload);
    },

    resetFilters: (state) => {
      state.filters = cloneDeep(initialState.filters);
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export default Evl0104m_Slice.reducer;
export const Evl0104mAction = Evl0104m_Slice.actions;
export const Evl0104mReducer = Evl0104m_Slice.reducer;
